export default __webpack_public_path__ + "static/media/Futuristic.5b2019cc.jpg";